<div [ngClass]="{'feedback-show': control?.errors && (control?.dirty || control?.touched),'feedback-hide': !(control?.errors && (control?.dirty || control?.touched)) }">
  <p class="ion-text-start error-text">{{feedback()}}</p>
</div>
